// extracted by mini-css-extract-plugin
export default {"container":"LoginView__container--DgSGEgY","contentBox":"LoginView__contentBox--cHKJJYe","logo":"LoginView__logo--UuLkrzq"};